import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "trigger-container" };
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = ["value"];
const _hoisted_4 = { class: "form-row" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = { class: "form-group" };
const _hoisted_7 = {
    key: 0,
    class: "error-message"
};
const _hoisted_8 = {
    key: 1,
    class: "success-message"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
    key: 2,
    class: "error-message"
};
import { ref, onMounted } from 'vue';
import { PublicClientApplication } from '@azure/msal-browser';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Trigger',
    setup(__props) {
        const selectedValue = ref('');
        const today = new Date().toISOString().slice(0, 10);
        const startDate = ref(today);
        const endDate = ref(today);
        const isLoading = ref(false);
        const errorMessage = ref('');
        const successMessage = ref('');
        const clientList = ref([]);
        const API_URL = __API_URL__;
        // Azure AD / MSAL configuration via environment variables (webpack DefinePlugin -> process.env)
        const AZURE_AD_CLIENT_ID = process.env.AZURE_AD_CLIENT_ID || '';
        const AZURE_AD_TENANT_ID = process.env.AZURE_AD_TENANT_ID || '';
        const FUNCTION_APP_SCOPE = process.env.FUNCTION_APP_SCOPE || '';
        if (!AZURE_AD_CLIENT_ID || !AZURE_AD_TENANT_ID || !FUNCTION_APP_SCOPE) {
            console.warn('Missing Azure AD config. Ensure webpack DefinePlugin sets process.env.AZURE_AD_CLIENT_ID, AZURE_AD_TENANT_ID, FUNCTION_APP_SCOPE');
        }
        const msalInstance = new PublicClientApplication({
            auth: {
                clientId: AZURE_AD_CLIENT_ID,
                authority: `https://login.microsoftonline.com/${AZURE_AD_TENANT_ID}`,
                redirectUri: window.location.origin,
            },
            cache: {
                cacheLocation: 'sessionStorage',
                storeAuthStateInCookie: false,
            },
        });
        // Initialize MSAL before any API usage
        const msalReady = msalInstance.initialize();
        const activeAccount = ref(null);
        const isAuthenticated = ref(false);
        async function ensureLoginAndGetToken() {
            await msalReady;
            // Handle redirect responses first
            await msalInstance.handleRedirectPromise().catch(() => { });
            const accounts = msalInstance.getAllAccounts();
            if (!activeAccount.value && accounts.length > 0) {
                activeAccount.value = accounts[0];
                msalInstance.setActiveAccount(activeAccount.value);
            }
            const request = {
                scopes: [FUNCTION_APP_SCOPE],
                account: activeAccount.value ?? accounts[0],
            };
            try {
                const result = await msalInstance.acquireTokenSilent(request);
                return result.accessToken;
            }
            catch {
                await msalInstance.loginRedirect({ scopes: [FUNCTION_APP_SCOPE] });
                throw new Error('Redirecting for authentication...');
            }
        }
        onMounted(async () => {
            try {
                await msalReady;
                await msalInstance.handleRedirectPromise();
                const accounts = msalInstance.getAllAccounts();
                if (accounts.length > 0) {
                    activeAccount.value = accounts[0];
                    msalInstance.setActiveAccount(activeAccount.value);
                    isAuthenticated.value = true;
                }
                else {
                    // Force auth on load: try silent, else redirect
                    try {
                        const result = await msalInstance.acquireTokenSilent({ scopes: [FUNCTION_APP_SCOPE] });
                        activeAccount.value = result.account ?? null;
                        if (activeAccount.value) {
                            msalInstance.setActiveAccount(activeAccount.value);
                            isAuthenticated.value = true;
                        }
                    }
                    catch {
                        await msalInstance.loginRedirect({ scopes: [FUNCTION_APP_SCOPE] });
                        return;
                    }
                }
            }
            catch (e) {
                console.error('MSAL redirect handling error:', e);
            }
            try {
                const response = await fetch('/clients.json');
                if (!response.ok) {
                    throw new Error('Failed to load client configuration');
                }
                const config = await response.json();
                clientList.value = config.clients.map((client) => ({
                    key: client.key,
                    name: client.name,
                }));
            }
            catch (error) {
                console.error('Failed to load clients:', error);
                errorMessage.value = 'Failed to load client list';
            }
        });
        const handleTrigger = async () => {
            if (!selectedValue.value) {
                errorMessage.value = 'Please select a client';
                return;
            }
            if (!startDate.value || !endDate.value) {
                errorMessage.value = 'Please select both start and end dates';
                return;
            }
            isLoading.value = true;
            errorMessage.value = '';
            successMessage.value = '';
            try {
                const token = await ensureLoginAndGetToken();
                const functionUrl = `${API_URL}/SendLogs`;
                const response = await fetch(functionUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        client: selectedValue.value,
                        startDate: startDate.value,
                        endDate: endDate.value,
                    }),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.text();
                successMessage.value = `Successfully triggered log import: ${data}`;
            }
            catch (error) {
                const message = error instanceof Error ? error.message : 'Unknown error';
                // If we triggered redirect, inform the user
                if (message.includes('Redirecting for authentication')) {
                    successMessage.value = '';
                    errorMessage.value = 'Redirecting to sign in...';
                }
                else {
                    errorMessage.value = `Failed to trigger request: ${message}`;
                }
            }
            finally {
                isLoading.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[7] || (_cache[7] = _createElementVNode("h2", null, "HTTP Logs Trigger", -1 /* CACHED */)),
                _cache[8] || (_cache[8] = _createElementVNode("p", null, "Select a Client to trigger an import of http logs to SEQ", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_2, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { for: "client-select" }, "Client:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedValue).value = $event)),
                        id: "client-select",
                        class: "method-select"
                    }, [
                        _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, "-- Choose a Client --", -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clientList.value, (client) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: client.key,
                                value: client.key
                            }, _toDisplayString(client.name), 9 /* TEXT, PROPS */, _hoisted_3));
                        }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, selectedValue.value]
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", { for: "start-date" }, "Start Date:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((startDate).value = $event)),
                            id: "start-date",
                            type: "date",
                            class: "date-input"
                        }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, startDate.value]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", { for: "end-date" }, "End Date:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((endDate).value = $event)),
                            id: "end-date",
                            type: "date",
                            class: "date-input"
                        }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, endDate.value]
                        ])
                    ])
                ]),
                (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                (successMessage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(successMessage.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                    onClick: handleTrigger,
                    class: "trigger-button",
                    disabled: isLoading.value
                }, _toDisplayString(isLoading.value ? 'Triggering...' : 'Trigger Request'), 9 /* TEXT, PROPS */, _hoisted_9),
                (!isAuthenticated.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Signing in…"))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
